export default "__VITE_ASSET__BrvuP3nD__"